
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/invisible-braces",
      function () {
        return require("private-next-pages/[lng]/invisible-braces.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/invisible-braces"])
      });
    }
  